var _defs, _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderwater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 520,
    viewBox: "0 0 360 520",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gu",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#667db6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#0082c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#667db6"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 520,
    fill: "url(#gu)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,380 C60,420 120,340 180,380 C240,420 300,340 360,380 L360,520 L0,520 Z",
    fill: "rgba(255,255,255,0.12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,420 C60,460 120,380 180,420 C240,460 300,380 360,420 L360,520 L0,520 Z",
    fill: "rgba(255,255,255,0.08)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderwater);
export default __webpack_public_path__ + "static/media/underwater.d6cb836a925cc39419f7b3d1a7b9e41d.svg";
export { ForwardRef as ReactComponent };